import axios from 'axios';
import { urlsServices } from '@/config/urls';
import { getTokenSSO } from '@/utils/index';

export const searchCepService = async (cep) => {
  return await axios.get(`${urlsServices.LEGADOWS}logradouroPorCEP/${cep}`).then((r) => r);
};

export const domainPostoGraduacao = async () => {
  return await axios
    .get(`${urlsServices.LEGADOWS}postoGraduacaoPorCorporacaoId/61`, {
      headers: { token: getTokenSSO() },
    })
    .then((r) => r);
};

export const domainEspecialidade = async () => {
  return await axios
    .get(`${urlsServices.LEGADOWS}especialidadesProfissionais`, {
      headers: { token: getTokenSSO() },
    })
    .then((r) => r);
};

export const domainListaEspecialidade = async () => {
  return await axios
    .get(`${urlsServices.LEGADOWS}Listaespecialidades`, {
      headers: { token: getTokenSSO() },
    })
    .then((r) => r);
};

export const domainSubEspecialidade = async (idEspecialidade) => {
  return await axios
    .get(`${urlsServices.LEGADOWS}subEspecialidadesProfissionais/${idEspecialidade}`, {
      headers: { token: getTokenSSO() },
    })
    .then((r) => r);
};

export const imgToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const formatCpf = (text) => {
  const badchars = /[^\d]/g;
  const mask = /(\d{3})(\d{3})(\d{3})(\d{2})/;
  const cpf = String(text).replace(badchars, '');
  return cpf.replace(mask, '$1.$2.$3-$4');
};

export const validarCpf = (cpf) => {
  var Soma = 0;
  var Resto;

  var strCPF = String(cpf).replace(/[^\d]/g, '');

  if (strCPF.length !== 11) return false;

  if (['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'].indexOf(strCPF) !== -1) return false;

  for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);

  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;

  if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

  Soma = 0;

  for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);

  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;

  return Resto === parseInt(strCPF.substring(10, 11));
};

export const isEmail = (email) => {
  let re = /\S+@\S+\.\S+/;
  return re.test(email);
};

export const convertBase64ToBlob = (base64Image) => {
  // Split into two parts
  const parts = base64Image.split(';base64,');

  // Hold the content type
  const imageType = parts[0].split(':')[1];

  // Decode Base64 string
  const decodedData = window.atob(parts[1]);

  // Create UNIT8ARRAY of size same as row data length
  const uInt8Array = new Uint8Array(decodedData.length);

  // Insert all character code into uInt8Array
  for (let i = 0; i < decodedData.length; ++i) {
    uInt8Array[i] = decodedData.charCodeAt(i);
  }

  // Return BLOB image after conversion
  return new Blob([uInt8Array], { type: imageType });
};

export const getAge = (dateString) => {
  const today = new Date();
  const birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};

// eslint-disable-next-line no-unused-vars
export function isValidTime(horaMinuto) {
  // verifica se a hora e o minuto estão no formato correto
  const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
  if (!regex.test(horaMinuto)) {
    return false;
  }

  // extrai a hora e o minuto da string
  const [hora, minuto] = horaMinuto.split(':').map(Number);

  // verifica se a hora está no intervalo de 0 a 23
  if (hora < 0 || hora > 23) {
    return false;
  }

  // verifica se o minuto está no intervalo de 0 a 59
  if (minuto < 0 || minuto > 59) {
    return false;
  }

  // se chegou até aqui, a hora e o minuto são válidos
  return true;
}

export function isValidDate(data) {
  // verifica se a data está no formato correto (dd/MM/yyyy)
  const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  if (!regex.test(data)) {
    return false;
  }

  // extrai o dia, mês e ano da string
  const [dia, mes, ano] = data.split('/').map(Number);

  // verifica se o ano é bissexto (para validar o dia 29 de fevereiro)
  const bissexto = (ano % 4 === 0 && ano % 100 !== 0) || ano % 400 === 0;

  // verifica se o mês está no intervalo de 1 a 12
  if (mes < 1 || mes > 12) {
    return false;
  }

  // verifica se o dia está no intervalo correto para o mês
  switch (mes) {
    case 2: // fevereiro
      if (bissexto && (dia < 1 || dia > 29)) {
        return false;
      } else if (!bissexto && (dia < 1 || dia > 28)) {
        return false;
      }
      break;
    case 4: // abril
    case 6: // junho
    case 9: // setembro
    case 11: // novembro
      if (dia < 1 || dia > 30) {
        return false;
      }
      break;
    default: // outros meses
      if (dia < 1 || dia > 31) {
        return false;
      }
      break;
  }

  // se chegou até aqui, a data é válida
  return true;
}

export function weekYear() {
  var currentDate = new Date();
  var year = new Date(currentDate.getFullYear(), 0, 1);
  var days = Math.floor((currentDate - year) / (24 * 60 * 60 * 1000));
  var week = Math.ceil((currentDate.getDay() + 1 + days) / 7);
  return week;
}

export function formatarData(data, mascara) {
  const dia = data.getDate().toString().padStart(2, '0');
  const mes = (data.getMonth() + 1).toString().padStart(2, '0');
  const ano = data.getFullYear().toString();
  const horas = data.getHours().toString().padStart(2, '0');
  const minutos = data.getMinutes().toString().padStart(2, '0');
  const segundos = data.getSeconds().toString().padStart(2, '0');
  return mascara.replace('DD', dia).replace('MM', mes).replace('YYYY', ano).replace('HH', horas).replace('mm', minutos).replace('ss', segundos);
}

export function removeMascaraCpf(cpf) {
  if (!cpf) {
    return '00000000000';
  } else {
    return cpf.replace(/\D/g, '');
  }
}

export function abrirImpressaoPorBlob(blobValue) {
  const blob = new Blob([blobValue], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);

  // Abra uma nova janela do navegador com o URL do Blob
  const janelaImpressao = window.open(url);

  // Aguarde um curto período para garantir que a janela seja aberta antes de iniciar a impressão
  setTimeout(() => {
    janelaImpressao.print();
    URL.revokeObjectURL(url); // Libera o URL temporário
  }, 1000);
}

export function encaminharEmailTo(assunto, corpo, alink) {
  const destinatario = 'exemplo@email.com';
  //alink.href = `mailto:${destinatario}?subject=${encodeURIComponent(assunto)}&body=${encodeURIComponent(corpo)}`;
  alink.href = `mailto:${destinatario}?subject=assunto&body=asdfasdfasd`;
  alink.click();
}
